/**
 * Волна D (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute exact path='/store'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import StoresPage from '@routes/Stores';

export const Route = createFileRoute('/store')({
  component: () => <CacheDataRoute component={StoresPage} path='/store' />
});
